import { Routes } from "@angular/router";

export const APP_ROUTES: Routes = [
  {
    path: "",
    loadComponent: () => import("./app.component").then(a => a.AppComponent),
    loadChildren: () => import("../../planning-portal-library/src/lib/planning-portal.routes")
      .then(pp => pp.PLANNING_PORTAL_ROUTES)
  } 
];
